module.exports = __webpack_public_path__ + "images/chrysler9dc7c52527838d5402f06c5cc64ded13.png";